import FlashLib from "flashlib_onlyplay";

import BaseButton from "Engine/base/ui/BaseButton";
import BaseCheckBox from "Engine/base/ui/BaseCheckBox";

import Main from "./Main";

import BackgroundContainer from "./background/BackgroundContainer";
import LogoContainer from "./logo/LogoContainer";

import ReelsContainer from "./reels/ReelsContainer";

import Symbol from "./symbols/Symbol";
import SymbolsFrames from "./symbols/SymbolsFrames";

import LinesContainer from "./lines/SlotLinesContainer";
import WinLineAnimated from "./lines/WinLineAnimated";

import SymbolsAnimationsContainer from "./symbolsAnimations/SymbolsAnimationsContainer";

import LineWinningContainer from "./lineWin/LineWinningContainer";

import FreeSpinsWindowContainer from "./freeSpins/FreeSpinsWindowContainer";
import SakuraMobileContainer from './freeSpins/SakuraMobileContainer';
import SakuraContainer from './freeSpins/SakuraContainer';

import OverlayContainer from "Engine/containers/overlay/BaseOverlayContainer";

import RespinButtonsContainer from "./respin/RespinButtonsContainer";
import RespinButton from "./respin/RespinButton";
import RespinInReelInfo from "./respin/RespinInReelInfo";
import RespinInReelInfoContainer from "./respin/RespinInReelInfoContainer";

import SettingsContainer from "Engine/containers/setting/BaseSettingsContainer";

import StartScreenContainer from './startScreen/startScreen';
import StartScreenContent from './startScreen/startScreenContent';

import ExpandingSymbolsContainer from "./expandingSymbols/ExpandingSymbolsContainer";

import FreeSpinsTopContainer from "./freeSpinsTop/FreeSpinsTopContainer";
import FreeSpinsCountContainer from "./freeSpinsTop/FreeSpinsCountContainer";
import FreeSpinsTotalWinContainer from "./freeSpinsTop/FreeSpinsTotalWinContainer";

import UiContainer from "./ui/BaseGameUiContainer";
import UiCoinValueContainer from "Engine/containers/ui/BaseCoinValueContainer";

import PurchaseContainer from './bonusPurchase/popupBonusPurchase';
import PurchaseCard from './bonusPurchase/ControllerBonusPurchaseCard';
import PurchaseConfirm from './bonusPurchase/purchaseConfirm';

import ButtonAnimated from './ui/ButtonAnimated';

import UiMobileContainer from "./ui/BaseGameUiContainer";

import InfoPopupContainer from 'Engine/containers/InfoPopupContainer';

import GameInfoContainer from "./gameInfo/GameInfoContainer";
import GameInfoContent from "./gameInfo/GameInfoContent";
import GameInfoControls from "./gameInfo/GameInfoControls";

import ControllerAntisipators from 'Engine/base/antisipators/ControllerAntisipators';

import PopupWin from './popups/popupWin/PopupWin';

import ControllerReels from 'Engine/base/reels/ControllerReels';

FlashLib.registerClass('BaseButton', BaseButton);
FlashLib.registerClass('BaseCheckBox', BaseCheckBox);

FlashLib.registerClass('Main', Main);
FlashLib.registerClass('BackgroundContainer', BackgroundContainer);
FlashLib.registerClass('ControllerReels', ControllerReels);
FlashLib.registerClass('ReelsContainer', ReelsContainer);
FlashLib.registerClass('Symbol', Symbol);
FlashLib.registerClass('SymbolsFrames', SymbolsFrames);
FlashLib.registerClass('WinLineAnimated', WinLineAnimated);
FlashLib.registerClass('LinesContainer', LinesContainer);
FlashLib.registerClass('SymbolsAnimationsContainer', SymbolsAnimationsContainer);
FlashLib.registerClass('LineWinningContainer', LineWinningContainer);
FlashLib.registerClass('FreeSpinsWindowContainer', FreeSpinsWindowContainer);
FlashLib.registerClass('LogoContainer', LogoContainer);

FlashLib.registerClass('OverlayContainer', OverlayContainer);
FlashLib.registerClass('OverlayMobileContainer', OverlayContainer);

FlashLib.registerClass('RespinButtonsContainer', RespinButtonsContainer);
FlashLib.registerClass('RespinButton', RespinButton);
FlashLib.registerClass('RespinInReelInfo', RespinInReelInfo);
FlashLib.registerClass('RespinInReelInfoContainer', RespinInReelInfoContainer);
FlashLib.registerClass('AntisipatorsController', ControllerAntisipators);


FlashLib.registerClass('SettingsContainer', SettingsContainer);

FlashLib.registerClass('StartScreenContainer', StartScreenContainer);
FlashLib.registerClass('StartScreenContent', StartScreenContent);

FlashLib.registerClass('ExpandingSymbolsContainer', ExpandingSymbolsContainer);
FlashLib.registerClass('SakuraContainer', SakuraContainer);
FlashLib.registerClass('SakuraMobileContainer', SakuraMobileContainer);

FlashLib.registerClass('FreeSpinsTopContainer', FreeSpinsTopContainer);
FlashLib.registerClass('FreeSpinsCountContainer', FreeSpinsCountContainer);
FlashLib.registerClass('FreeSpinsTotalWinContainer', FreeSpinsTotalWinContainer);

FlashLib.registerClass('UiContainer', UiContainer);
FlashLib.registerClass('UiCoinValueContainer', UiCoinValueContainer);
FlashLib.registerClass('PurchaseContainer', PurchaseContainer);
FlashLib.registerClass('PurchaseCard', PurchaseCard);
FlashLib.registerClass('PurchaseConfirm', PurchaseConfirm);

FlashLib.registerClass('ButtonAnimated', ButtonAnimated);

FlashLib.registerClass('UiMobileContainer', UiMobileContainer);

FlashLib.registerClass('InfoPopupContainer', InfoPopupContainer);

FlashLib.registerClass('GameInfoContainer', GameInfoContainer);
FlashLib.registerClass('GameInfoContent', GameInfoContent);
FlashLib.registerClass('GameInfoControls', GameInfoControls);

FlashLib.registerClass('PopupWin', PopupWin);
